import { render, staticRenderFns } from "./RoomListPromotionItem.vue?vue&type=template&id=13efb4f2&"
import script from "./RoomListPromotionItem.vue?vue&type=script&lang=js&"
export * from "./RoomListPromotionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports